import React from 'react'
import { StyleSheet, Defs, Svg, Path, G, Font } from '@react-pdf/renderer'

import Bold from '../Fonts/DM_Sans/DMSans-Bold.ttf'
import Medium from '../Fonts/DM_Sans/DMSans-Medium.ttf'
import Regular from '../Fonts/DM_Sans/DMSans-Regular.ttf'

Font.register({
  family: 'Dm Sans',
  fontStyle: 'normal',
  fontWeight: 'normal',
  fonts: [
    {
      src: Regular
    },
    {
      src: Bold,
      fontWeight: 'bold'
    },
    {
      src: Medium,
      fontWeight: 500
    }
  ]
})

// Create styles
export const styles = StyleSheet.create({
  banner: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    height: 15
  },
  page: {
    position: 'relative',
    padding: 0,
    backgroundColor: '#5BAAE1',
    fontFamily: 'Dm Sans'
  },
  colLeft: {
    width: '80%'
  },
  colRight: {
    marginTop: 10,
    width: '20%',
    color: '#F9F9F9',
    textAlign: 'right',
    fontWeight: 700
  },
  idSection: { fontSize: 14, marginTop: -15, fontWeight: 'bold' },
  endDate1: {
    textAlign: 'right',
    fontSize: 14,
    marginBottom: 3,
    fontWeight: 'bold'
  },
  endDate2: {
    textAlign: 'right',
    fontSize: 16,
    marginBottom: 20,
    fontWeight: 'bold'
  },
  certificateWrapper: {
    alignItems: 'flex-end'
  },
  header: {
    width: 250,
    textAlign: 'center',
    padding: 10,
    backgroundColor: '#fff',
    borderRadius: 35,
    fontSize: 20,
    fontWeight: 'bold',
    color: '#6F6F6F',
    fontFamily: 'Dm Sans',
    marginTop: 20
  },
  headerOther: {
    backgroundColor: '#A9B2BA',
    color: '#F9F9F9'
  },
  userName: {
    marginTop: 20,
    fontSize: 40,
    color: '#FFF',
    lineHeight: 1.6,
    fontWeight: 'bold',
    fontFamily: 'Dm Sans',
    marginBottom: 15,
    justifyContent: 'center',
    height: 96
  },
  userNameOther: {
    color: '#505050'
  },
  expName: {
    color: '#F9F9F9',
    fontSize: 26,
    fontWeight: 'bold',
    fontFamily: 'Dm Sans',
    height: 63
  },

  expNameOther: {
    color: '#727272'
  },
  expSeparator: {
    width: 35,
    borderBottomWidth: 3,
    borderBottomColor: '#FFF',
    opacity: 0.5,
    marginBottom: 50,
    marginTop: 15
  },
  expSeparatorOther: {
    borderBottomColor: '#727272'
  },
  skillSection: {
    color: '#F9F9F9'
  },

  bottom: {
    borderTopWidth: 1,
    borderTopColor: '#C0C0C0',
    position: 'absolute',
    bottom: 10,
    zIndex: 100,
    left: 80,
    right: 80
  }
})
type StarSvgProps = {
  styles?: {}
  color?: string
}
export const StarSvg = ({ styles, color }: StarSvgProps) => (
  <Svg style={styles} width='103' height='103' viewBox='0 0 103 103'>
    <Path
      fillRule='evenodd'
      d='M102.021 41.8657V39.5675H101.995C101.432 37.5366 100.562 35.7195 98.8227 34.4635C97.4157 33.4748 95.8295 33.2076 94.2178 32.9671C86.7219 31.818 79.2005 30.6689 71.679 29.5733C70.1185 29.3328 69.044 28.5578 68.3276 27.0346C66.187 22.4312 64.0173 17.8479 61.8484 13.2662C60.492 10.401 59.1359 7.53641 57.7874 4.66786C56.3036 1.48788 53.8987 -0.195642 50.4706 0.0181383C47.5541 0.231919 45.5586 1.88872 44.2539 4.61442C43.1794 6.88586 42.1113 9.15061 41.0432 11.4154C39.9751 13.6801 38.907 15.9448 37.8325 18.2162C37.5768 18.7505 37.3202 19.2847 37.0635 19.8192C35.9081 22.2251 34.751 24.6343 33.6625 27.0614C32.9462 28.638 31.8205 29.3595 30.2088 29.6L30.2086 29.6C22.3035 30.7758 14.3983 31.9516 6.49319 33.1808C3.49996 33.6351 1.35098 35.3454 0.4044 38.4185C-0.56776 41.5183 0.250901 44.2173 2.45105 46.462L17.6474 61.9343C18.3638 62.6826 19.1057 63.4308 19.8476 64.179C20.8197 65.141 21.2035 66.2634 20.9732 67.6529C19.7197 75.2421 18.4661 82.8581 17.2637 90.474L17.2443 90.5952C16.9685 92.322 16.6811 94.1213 16.9311 95.8185C17.5963 100.522 22.5338 103.247 26.7295 101.43C27.7349 100.994 28.6981 100.456 29.6504 99.9228C29.9824 99.7371 30.313 99.5522 30.6437 99.3726C32.295 98.4663 33.9482 97.562 35.6018 96.6576C39.9941 94.2551 44.3888 91.8512 48.7565 89.4051C50.3171 88.55 51.6986 88.5233 53.2592 89.4051C60.2434 93.3066 67.2787 97.1546 74.2885 100.976C77.5376 102.766 80.7866 102.285 83.2938 99.6131C85.0846 97.7158 85.5963 95.391 85.1613 92.7989C84.9887 91.7441 84.8161 90.689 84.6434 89.6335C83.4598 82.399 82.2736 75.1494 81.068 67.9202C80.8122 66.3168 81.2471 65.0876 82.3472 63.992C84.743 61.5725 87.1287 59.1425 89.5132 56.7137C92.5015 53.67 95.4879 50.6281 98.4902 47.611C100.127 45.9542 101.56 44.2707 102.021 41.8657Z'
      fill={color}
    />
  </Svg>
)

export const CertificateImg = ({ color }: StarSvgProps) => (
  <Svg width='141' height='132' viewBox='0 0 141 132'>
    <G>
      <Path
        d='M103.348 111.459C103.266 111.018 103.238 110.798 103.178 110.582C102.498 108.14 102.507 106.06 105.03 104.412C106.115 103.7 106.726 102.148 107.342 100.877C107.751 100.032 108.156 99.5727 109.116 99.7243C109.452 99.7747 109.806 99.7105 110.146 99.7334C113.924 99.9997 114.967 98.8657 115.271 95.4545C115.574 92.0754 118.759 89.6054 122.661 89.1417C125.662 88.7836 126.269 88.1132 126.269 85.1014C126.269 65.5064 126.269 45.9069 126.269 26.3118C126.269 23.3827 125.529 22.5884 122.592 22.3267C118.529 21.9594 115.62 19.1726 115.073 15.114C114.724 12.5155 113.855 11.7212 111.281 11.7212C84.0996 11.7166 56.9136 11.7166 29.7321 11.7212C27.1444 11.7212 26.2712 12.5155 25.9219 15.0911C25.3611 19.2369 22.4288 22.0054 18.2509 22.3359C15.5714 22.5471 14.7257 23.4378 14.7257 26.119C14.7257 45.8885 14.7211 65.6534 14.7257 85.4228C14.7257 88.026 15.5024 88.8524 18.136 89.1279C22.6494 89.6008 25.3336 92.1764 25.9494 96.6206C26.2712 98.9575 27.1582 99.7288 29.6172 99.7288C39.9401 99.738 50.263 99.7288 60.5859 99.7288C61.2109 99.7288 61.836 99.7288 62.5116 99.7288C63.4263 102.415 64.9292 104.591 67.2365 106.184C67.5168 106.377 67.6777 106.964 67.6409 107.341C67.5076 108.649 67.264 109.944 67.025 111.455H65.3383C44.9223 111.455 24.5063 111.455 4.09027 111.455C0.895958 111.455 -0.00488281 110.559 -0.00488281 107.382C-0.000286685 72.9441 -0.000286685 38.5105 -0.000286685 4.07234C-0.000286685 0.913638 0.928131 0 4.11784 0C48.3923 0 92.6622 0 136.937 0C140.08 0 140.995 0.932002 140.995 4.12744C140.995 38.5059 140.995 72.8844 140.995 107.263C140.995 110.578 140.131 111.45 136.84 111.45C126.288 111.45 115.735 111.45 105.182 111.45H103.344L103.348 111.459Z'
        fill={color}
      />
      <Path
        d='M60.9172 93.8706C60.2461 93.8706 59.8647 93.8706 59.4878 93.8706C50.6586 93.8706 41.8295 93.8523 33.0003 93.8936C31.9202 93.8982 31.4376 93.6135 31.0607 92.5346C29.567 88.2557 26.5014 85.4964 22.2637 83.9951C21.7352 83.8069 21.1883 83.6553 20.6367 83.4855V28.4239C22.8842 27.1567 25.2237 26.2982 26.9334 24.7418C28.6478 23.1808 29.8979 21.0184 31.0194 18.9432C31.5755 17.9147 32.0075 17.5566 33.1382 17.5566C58.0768 17.5888 83.0154 17.575 107.954 17.6071C108.528 17.6071 109.494 17.8964 109.618 18.2729C111.369 23.5297 115.083 26.5691 120.345 27.9831V83.1274C117.78 84.5047 115.308 85.8316 112.821 87.1676C113.603 82.8335 111.948 79.1606 109.002 75.8871C108.597 75.4372 108.45 74.6475 108.404 74.0002C107.913 66.7737 103.418 62.3111 96.2154 61.8428C95.4387 61.7923 94.5562 61.4067 93.9541 60.9016C88.1125 56.0304 82.1559 56.035 76.4061 60.9154C75.8086 61.4204 74.9216 61.7923 74.1448 61.8382C66.9933 62.2882 62.4063 66.8288 61.9053 73.9956C61.8548 74.6888 61.6709 75.4969 61.2527 76.0157C56.151 82.3101 55.9855 86.8783 60.9126 93.8752L60.9172 93.8706ZM70.5277 41.0633C80.7816 41.0633 91.0402 41.0633 101.294 41.0633C101.979 41.0633 102.678 41.0817 103.349 40.9577C104.76 40.7006 105.559 39.7961 105.665 38.3683C105.771 36.867 105.077 35.8064 103.62 35.3932C102.921 35.1958 102.149 35.1958 101.409 35.1912C92.4144 35.1775 83.4198 35.182 74.4252 35.182C62.797 35.182 51.1642 35.182 39.536 35.182C36.7002 35.182 35.3535 36.114 35.3213 38.0745C35.2846 40.1038 36.6496 41.0541 39.5911 41.0587C39.991 41.0587 40.3955 41.0587 40.7953 41.0587C50.7046 41.0587 60.6184 41.0587 70.5277 41.0587V41.0633ZM70.4771 46.9537C60.2232 46.9537 49.9646 46.9537 39.7106 46.9537C39.0258 46.9537 38.3226 46.9308 37.6562 47.0547C36.2498 47.3164 35.4362 48.2117 35.3351 49.6396C35.2294 51.1409 35.9234 52.2014 37.3758 52.6192C38.0744 52.8212 38.8466 52.8212 39.5865 52.8212C49.3257 52.835 59.0649 52.8304 68.8041 52.8304C79.7475 52.8304 90.6909 52.8304 101.634 52.8304C104.314 52.8304 105.647 51.8663 105.683 49.9426C105.725 47.9408 104.387 46.9675 101.588 46.9537C101.188 46.9537 100.784 46.9537 100.384 46.9537C90.4151 46.9537 80.4461 46.9537 70.4771 46.9537ZM70.4955 29.31C75.2525 29.31 80.0095 29.3008 84.7665 29.3146C86.1407 29.3146 87.2484 28.8968 87.8413 27.5699C88.8111 25.4029 87.2254 23.4517 84.4356 23.4471C75.1514 23.4287 65.8672 23.4333 56.5784 23.4471C54.2436 23.4471 52.9291 24.5398 52.9245 26.3946C52.9245 28.2861 54.1563 29.2962 56.5646 29.3054C61.2067 29.3192 65.8488 29.3054 70.4909 29.3054L70.4955 29.31Z'
        fill={color}
      />
      <Path
        d='M107.099 84.9728C107.154 87.0251 106.249 88.6962 104.842 90.0139C103.174 91.5795 102.563 93.4021 102.508 95.6472C102.397 100.078 100.062 102.364 95.5905 102.424C93.5176 102.451 91.909 103.044 90.3693 104.485C86.6786 107.942 83.6359 107.933 79.9912 104.485C78.5158 103.089 76.9715 102.451 74.9447 102.424C70.2152 102.355 67.8574 100.023 67.8023 95.3029C67.7793 93.269 67.1496 91.7356 65.757 90.2618C62.3007 86.6119 62.3053 83.5358 65.757 79.895C67.1496 78.4258 67.7839 76.8924 67.8069 74.8539C67.862 70.125 70.1969 67.8203 74.9447 67.7377C76.9624 67.7009 78.5158 67.0719 79.9958 65.6762C83.6497 62.2191 86.6602 62.2053 90.3693 65.6716C91.909 67.1087 93.5222 67.7101 95.5859 67.7422C100.145 67.8203 102.393 70.0654 102.517 74.6749C102.577 76.8006 103.142 78.5268 104.723 80.0098C106.125 81.3229 107.095 82.9527 107.099 84.9682V84.9728Z'
        fill={color}
      />
      <Path
        d='M73.5194 107.814C74.765 108.443 75.7991 108.741 76.5483 109.375C82.0177 114.026 88.1627 114.062 93.6872 109.476C94.4916 108.81 95.5625 108.461 96.8172 107.809C97.4974 112.446 98.0995 116.555 98.697 120.669C99.0555 123.158 99.4048 125.651 99.7541 128.139C99.9426 129.461 99.7817 130.659 98.5683 131.486C97.3642 132.308 96.2197 132.028 95.0201 131.412C92.1705 129.952 89.2704 128.593 86.4392 127.101C85.5153 126.615 84.8213 126.656 83.9159 127.129C80.9238 128.69 77.9042 130.196 74.8523 131.633C72.6002 132.693 70.44 131.233 70.5182 128.809C70.5274 128.58 70.5549 128.355 70.5871 128.125C71.5339 121.569 72.4807 115.013 73.5194 107.819V107.814Z'
        fill={color}
      />
      <Path
        d='M112.532 88.7605C111.75 90.1792 110.974 91.6025 110.192 93.0211C110.031 92.9385 109.875 92.8512 109.714 92.7686C110.477 91.3316 111.24 89.8945 111.999 88.4575C112.173 88.5585 112.353 88.6595 112.527 88.7651L112.532 88.7605Z'
        fill={color}
      />
    </G>
    <Defs></Defs>
  </Svg>
)
